import _ from "lodash";

export const userFirstLastName = (fullName) => {
    const nameSplited = fullName.split(' ')
    const aSize = _.size(nameSplited)
    if (aSize > 1) {
        return `${_.startCase(nameSplited[0].toLowerCase())} ${_.startCase(
            nameSplited[aSize - 1].toLowerCase()
        )}`
    } else {
        return `${_.startCase(nameSplited[0].toLowerCase())}`
    }
}